import React from 'react';


const ErrorIcon = () => {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="100" height="100" viewBox="0 0 100 100">
      <defs>
        <path id="98sg37o15a" d="M50 8.417c22.966 0 41.583 18.617 41.583 41.583 0 22.966-18.617 41.583-41.583 41.583C27.034 91.583 8.417 72.966 8.417 50 8.417 27.034 27.034 8.417 50 8.417zm0 4c-20.757 0-37.583 16.826-37.583 37.583 0 20.757 16.826 37.583 37.583 37.583 20.757 0 37.583-16.826 37.583-37.583 0-20.757-16.826-37.583-37.583-37.583zm0 51.208c1.68 0 3.042 1.362 3.042 3.042 0 1.68-1.362 3.041-3.042 3.041-1.68 0-3.042-1.361-3.042-3.041S48.32 63.625 50 63.625zm0-34.375c1.105 0 2 .895 2 2v25.26c0 1.105-.895 2-2 2s-2-.895-2-2V31.25c0-1.105.895-2 2-2z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <g transform="translate(-670 -261) translate(0 -1) translate(320 167) translate(0 95) translate(350)">
                  <mask id="tozuus7q9b" fill="#fff">
                    <use xlinkHref="#98sg37o15a" />
                  </mask>
                  <use fill="#333" fillRule="nonzero" xlinkHref="#98sg37o15a" />
                  <g fill="#E60000" mask="url(#tozuus7q9b)">
                    <path d="M0 0H100V100H0z" />
                  </g>
                  <path d="M0 0H100V100H0z" mask="url(#tozuus7q9b)" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}



export default ErrorIcon;